// @ts-check

import { get_forms } from '~/api/zero-api';
import { generateDataGridEventNames } from '~/components/Shared/ZeroDataGrid/ZeroDataGrid.hooks';
import { memoize } from "lodash-es";
import { AgGridFilter } from '~/other/agGridHelper';
import { IncidentTemplateActionCell, IncidentTemplateNameCell } from '~/components/Incidents/IncidentTemplateDataGrid/IncidentTemplateDataGrid.cells';

import { SingleAvatarCell } from '~/components/Shared/DataGrid/SharedDataGridCells';
import { dateFormatterNoTime, formatName } from '~/other/Helper';

export const EventNames = generateDataGridEventNames('IncidentTemplateDataGrid');

export const DEFAULT_SORT_MODEL = [
    {
        colId: "name",
        sort: "asc",
    },
];

export function getSortByColumnName(colName) {
    switch (colName) {
        default: return colName;
    }
}

/**
 * @returns {AgGrid.GridOptions['columnDefs']}
 */
export function getColumnDefs() {
    /** @type {AgGrid.GridOptions['columnDefs']} */
    let defs = [
        {
            headerName: "",
            field: "_actions_",
            width: 50,
            cellRenderer: IncidentTemplateActionCell,
            resizable: false,
            sortable: false,
            suppressMovable: true,
            lockPosition: "left",
            cellStyle: {
                padding: 0,
            }
        },
        {
            headerName: "Template",
            field: "name",
            initialSort: "asc",
            cellRenderer: IncidentTemplateNameCell,
            ...AgGridFilter.textNoBlankOptions,
        },
        {
            headerName: "Last Edited",
            field: "edited_at",
            width: 180,
            valueFormatter: ({value}) => {
                if (typeof value !== "number") {
                    return "";
                }
                return dateFormatterNoTime(value);
            },
            ...AgGridFilter.date,
        },
        {
            headerName: "Last Edited By",
            field: "edited_by",
            width: 170,
            sortable: false,
            cellRenderer: SingleAvatarCell,
            valueFormatter: ({value: user}) => formatName(user, {defaultName: ""}),
        },
        {
            headerName: "Submissions",
            field: "submissions_count",
            width: 165,
        },
    ];

    return defs;
}

/**
 * @param {URLSearchParams} queryParams 
 * @returns {Promise<{forms: any[], totalForms: number}>}
 */
async function _loadIncidentTemplates(queryParams) {
    const response = await get_forms(`?${queryParams}`);
    const content = await response.json();
    const forms = content.results ?? [];
    const totalForms = content.total ?? 0;

    return { forms, totalForms };
}

export const loadIncidentTemplates = memoize(_loadIncidentTemplates, (queryParams) => queryParams.toString());

/**
 * 
 * @param {any} form 
 * @param {string} orgId 
 */
export function getIncidentTemplateAnalyticsLink(form, orgId) {
    return `/${orgId}/home/manage_incident_templates/${form.form_uuid}/analytics`;
} 